"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var storage_base_service_1 = require("./storage-base.service");
var LocalStorage = (function (_super) {
    __extends(LocalStorage, _super);
    function LocalStorage() {
        return _super.call(this, window.localStorage) || this;
    }
    return LocalStorage;
}(storage_base_service_1.StorageBase));
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=D:/a/1/s/base/src/local-storage.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/local-storage.service.js